// export const SUBSCRIPTION_LINK = `ws://30t4.smartiot.city:12345/graphql`;
// export const UPLOAD_LINK = `http://30t4.smartiot.city:12345/graphql`;

// export const SUBSCRIPTION_LINK = `ws://tn01.lirecon.com:12345/graphql`;
// export const UPLOAD_LINK = `http://tn01.lirecon.com:12345/graphql`;

// export const SUBSCRIPTION_LINK = `ws://demo.nissetech.io:12345/graphql`;
// export const UPLOAD_LINK = `http://demo.nissetech.io:12345/graphql`;

// export const SUBSCRIPTION_LINK = `ws://10.10.0.50:12345/graphql`;
// export const UPLOAD_LINK = `http://10.10.0.50:12345/graphql`;

export const SUBSCRIPTION_LINK = `ws://live.nissetech.io/graphql`;
export const UPLOAD_LINK = `https://live.nissetech.io/graphql`;